// import HelloWorld from '../component/HelloWorld';

export default [
  // {
  //   path: '/HelloWorld',
  //   component: HelloWorld
  // }
  { path: '/Callback', 
    name: 'Callback',
    component: () => import('../component/lining/modal/Callback.vue') ,
    meta: {
      requiresAuth: false
    }
  },
  { path: '/SSOGetCode', 
    name: 'SSOGetCode',
    component: () => import('../component/lining/modal/SSOGetCode.vue') ,
    meta: {
      requiresAuth: false
    }
  }
];
